<template>
	<transition name="fade">
		<div v-if="visible" class="login-dialog">

			<div class="login_box loginSeries">
				<i class="iconfont icon-guanbi portal-login-iframe-close-icon" @click="portalLoginClose"></i>
				<div class="core" @click="operation">登录</div>
				<p class="title" style="margin-bottom: 31px;">欢迎注册亿众</p>


				<Form ref="ruleForm" :model="data" :rules="rules" class="userinfo registerInfo">
					<FormItem prop="loginName">
						<div class="input-content">
							<span class="reg-mobile-input-prefix">+86</span>
							<Input type="number" id="register_mobile" v-model="data.loginName" placeholder="手机号" />
						</div>
					</FormItem>
					<FormItem prop="pictureCode">
						<div class="input-content">
							<Input type="text" v-model="data.pictureCode" placeholder="图片验证码" style="width: 60%;"
								autocomplete="new-password" />
							<img class="picture" alt="图形验证码" :src="uuPicCode">
							<span class="pictureCodeBtn" @click="getPictureCode()">换一张</span>
						</div>
					</FormItem>
					<FormItem prop="password">
						<div class="input-content">
							<!-- 	<p class="suggest">
								<i>!</i>
								<i>密码长度6-16位，支持数字、字母、字符</i>
							</p> -->
							<Input type="password" id="password" v-model="data.password" placeholder="密码"
								autocomplete="new-password" />
						</div>
					</FormItem>
					<FormItem prop="password2">
						<div class="input-content">
							<Input type="password" id="password2" v-model="data.password2" placeholder="确认密码"
								autocomplete="new-password" />
						</div>
					</FormItem>
					<FormItem prop="code">
						<div class="input-content">
							<Input type="number" v-model="data.code" placeholder="短信验证码" style="width: 60%;" />
							<span :class="['getCode',!!cooling?'forbid':'']">
								<i @click="getCaptcha(data.loginName,data.uuid,data.pictureCode)">
									{{ cooling ? "重新发送(" + cooling + ")" : "发送验证码" }}
								</i>
							</span>
						</div>
					</FormItem>

					<div style="text-align: left;">
						<Checkbox v-model="checkStatus">
							<i>我已阅读并同意</i>
							<i @click="toRegistration($event)" style="color: var(--mainColor);">《注册协议》</i>
							<i>、</i>
							<i @click="toDisclaimer($event)" style="color: var(--mainColor);">《免责声明》</i>
							<i>和</i>
							<i @click="toConfidentiality($event)" style="color: var(--mainColor);">《隐私政策》</i>
						</Checkbox>
					</div>

					<FormItem>
						<button type="button" class="loginSeriesBtn buttonFill" @click="register" :disabled="!checkStatus">注册</button>
					</FormItem>
				</Form>

			</div>

			<RegistrationProtocol v-if="agreement" :show="agreement" @childData="handleAgreement" />
			<Disclaimer v-if="disclaimer" :show="disclaimer" @childData="handleDisclaimer" />
			<PrivacyPolicy v-if="privacyPolicy" :show="privacyPolicy" @childData="handlePrivacyPolicy" />

		</div>
	</transition>
</template>

<script>
	import publicMethod from '@/views/publicMethod'
	import RegistrationProtocol from './registrationProtocol'
	import Disclaimer from './disclaimer'
	import PrivacyPolicy from './privacyPolicy'



	import qs from 'qs'
	import axios from 'axios'

	import {
		mapActions,
		mapMutations
	} from 'vuex'

	import {
		eventBus
	} from '@/components/login/eventBus.js';

	export default {
		name: 'registerDialog',
		mixins: [publicMethod],
		components: {
			RegistrationProtocol,
			Disclaimer,
			PrivacyPolicy

		},
		data() {
			return {
				visible: false,
				data: {
					type: 2, // 手机2,邮箱1
					serviceType: 1, // 寻求服务类型
					loginName: "", // 账号
					password: "", // 密码
					password2: "", // 确认密码
					pictureCode: "", // 图片验证码
					code: "", // 手机验证码
					uuid: '' //图片验证码uuid
				},
				uuPicCode: '',
				cooling: '',
				noteStatus: 200,
				noteMsg: '',
				checkStatus: false,
				agreement: false, //注册协议
				disclaimer: false, //免责声明
				privacyPolicy: false //隐私政策


			};
		},
		props: {
			phone: {
				type: Array,
				default: function() {
					return [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}, {
						required: true,
						pattern: /^1[3|4|5|6|7|8|9]\d{9}$/,
						message: '手机号格式不正确',
						trigger: 'blur'
					}, {
						validator: (rule, value, callback) => this.phoneVerify(rule, value, callback),
						trigger: 'blur'
					}]
				}
			},
			imgCode: {
				type: Array,
				default: function() {
					return [{
							required: true,
							message: '图片验证码不能为空',
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => this.pictureCdoeVerify(rule, value, callback),
							trigger: 'blur'
						}
					]
				}
			},
			passwordRules: {
				type: Array,
				default: () => {
					return [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}, {
						required: true,
						pattern: /^[A-Za-z0-9@#$%]{6,16}$/,
						message: '密码格式不正确',
						trigger: 'blur'
					}]
				}
			},
			confirmPassword: {
				type: Array,
				default: function() {
					return [{
							required: true,
							message: '请再次输入密码',
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => this.validateConfirmPassword(rule, value, callback), // 使用箭头函数
							trigger: 'blur'
						}
					]
				}
			},
			code: {
				type: Array,
				default: function() {
					return [{
						required: true,
						validator: (rule, value, callback) => this.phoneCodeStatus(rule, value, callback), // 使用箭头函数
						trigger: 'blur'
					}]
				}
			}

		},
		computed: {
			rules() {
				return {
					loginName: this.phone,
					pictureCode: this.imgCode,
					password: this.passwordRules,
					password2: this.confirmPassword,
					code: this.code

				}
			},
		},
		created() {
			// 订阅事件以显示登录对话框
			eventBus.$on('show-register-dialog', () => {
				this.show();
			});
			
			eventBus.$on('hide-dialog', () => {
				this.hide();
			});
			
		},
		mounted() {
			this.getPictureCode()

		},
		methods: {
			show() {
				this.visible = true;
				document.body.style.overflow = 'hidden'
			},
			hide() {
				this.visible = false;
				document.body.style.removeProperty('overflow');
			},
			operation() {
				this.visible = false;
				document.body.style.removeProperty('overflow');

				eventBus.$emit('show-login-dialog');
			},
			validateConfirmPassword(rule, value, callback) {
				if (value !== this.data.password) {
					callback(new Error('两次密码输入不一致'));
				} else {
					callback();
				}
			},
			phoneCodeStatus(rule, value, callback) {
				if (this.noteStatus == 200) {
					callback();
				} else {
					callback(new Error(this.noteMsg));
				}
			},
			getPictureCode: function() {
				this.$get(this.domain.dataRealization + "dataCustomer/getVerifiCode", "").then((res) => {
					console.log(res)
					if (res.code == 200 && res.content) {
						this.data.uuid = res.content.uuid;
						this.uuPicCode = res.content.image;
					}
				})
			},
			pictureCdoeVerify(rule, value, callback) {
				this.$get(this.domain.dataRealization + "dataCustomer/checkVerifiCode", {
					test: this.data.pictureCode,
					uuid: this.data.uuid
				}).then((res) => {
					if (res.code != 200) {
						callback(new Error('图片验证码错误'));
					} else if (res.code == 200) {
						callback();
					}
				})
			},
			register() {
				var this_ = this;

				this.$refs.ruleForm.validate((valid) => {
					console.log(valid)
					if (valid) {
						console.log('可以保存')
						console.log(this.data)

						this.$post(this.domain.dataRealization + 'dataCustomer/registered', qs.stringify(this.data))
							.then((res) => {
								if (res.data.code == 200) {
									this.operation()

								} else {
									this.$Message.error(res.data.message)
								}
							});
					}
				})


			},
			phoneVerify(rule, value, callback) {
				var this_ = this;

				var params = {};
				params.type = this_.data.type;
				params.loginName = this_.data.loginName;
				this_.$post(this.domain.dataRealization + "dataCustomer/checkCustomer", qs.stringify(params)).then((res) => {
					var data = res.data;
					if (data) {
						if (data.code == 101) { //用户名未注册   返回103,已注册101
							callback(new Error('该账号已注册'));
						} else if (data.code == 103) {
							callback();
						}
					};
				});

			},
			toRegistration(event) {
				event.stopPropagation();
				event.preventDefault(); // 阻止默认行为

				this.agreement = true
			},
			toDisclaimer(event) {
				event.stopPropagation();
				event.preventDefault(); // 阻止默认行为
				this.disclaimer = true
			},
			toConfidentiality(event) {
				event.stopPropagation();
				event.preventDefault(); // 阻止默认行为
				this.privacyPolicy = true
			},
			handleAgreement(data) {
				this.agreement = data
			},
			handleDisclaimer(data) {
				this.disclaimer = data
			},
			handlePrivacyPolicy(data) {
				this.privacyPolicy = data
			},

		}
	};
</script>

<style scoped>
	@import "~@/assets/css/login/mask.less";
</style>